<!--
    描述：签署合同
    时间：2022-06-24
    Created by 张卫华
-->
<template>
  <div class="initiate-cert-page">
    <div v-if="stepIndex == 1" class="dv-step1">
      <el-form :model="objectForm"
               :rules="objectFormRules"
               ref="objectForm"
               label-width="110px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="签署人类型"
                          prop="type"
                          :show-message="false">
              <!--
              <el-select v-model="objectForm.type" placeholder="请选择签署人类型">
                <el-option v-for="(item, index) in typeDL" :key="index" :value="item.value" :label="item.sname"></el-option>
              </el-select>
              -->
              <el-select v-model="objectForm.type" placeholder="请选择签署人类型">
                <el-option value="0" label="用户手动签署（个人）"></el-option>
                <el-option value="1" label="用户手动签署（机构）"></el-option>
                <el-option value="2" label="平台方自动签署"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="objectForm.type != '2'">
          <el-col :span="24">
            <el-form-item label="签署人身份"
                          prop="mobileNo"
                          :show-message="false">
              <el-input v-model="objectForm.mobileNo" placeholder="请输入手机号或E签宝会员ID"
                        autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="签署文件ID"
                          prop="fileId"
                          :show-message="false">
              <el-input type="textarea" v-model="objectForm.fileId" placeholder="请输入签署文件ID"
                        autocomplete="off" :rows="4"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="text-left">
          <div style="margin-left: 110px">待签署文件ID，可以是多份</div>
        </el-row>
      </el-form>
    </div>

    <div v-if="stepIndex == 2" class="dv-step2" @click="nextStep">
      <div class="dv-tip">
        请拿出手机，打开微信或支付宝扫描下面的二维码，在移动端完成会员注册认证过程。
      </div>

      <div class="dv-qr-code">
        <!--
        <img src="http://172.16.0.153/huangfeng/ngsyh/images/%E5%BE%AE%E4%BF%A1%E7%99%BB%E5%BD%95/u924.png" class="img-qr-code"/>
        {{orderObj.qrCodeText}}
        -->

        <vue-qr :text="orderObj.qrCodeText" :size="286"></vue-qr>
      </div>
    </div>

    <div v-if="stepIndex == 3" class="dv-step3">
      <div class="dv-tip">
        恭喜您已完成【
        <span class="dv-key-tip">政府采购竞争性谈判采购合同</span>】，【
        <span class="dv-key-tip">采购协议</span>】文件签署！
      </div>

      <div class="dv-suc-btn">
        <el-button type="primary"
                   size="small"
                   class="btn btn-blue"
                   :loading="btnLoading"
                   >前往查看签署文件</el-button>

        <el-button type="primary"
                   size="small"
                   class="btn btn-blue"
                   :loading="btnLoading"
                   @click="closeDialog">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import * as API from 'api/modules/es/es_order'
import * as APIHistory from 'api/modules/es/es_order_history'
export default {
  name: "initiate-certification-dialog",
  components : {
    vueQr,
  },
  data(){
    return {
      btnLoading : false,
      //认证步骤序号
      stepIndex : 1,

      //签署人类型下拉信息
      typeDL : [],

      objectForm : {
        type : '0',
        mobileNo : '17730217271',
        fileId : 'http://112.31.81.178/file/group1/2022-06-23/E签宝合同测试.docx',
      },
      objectFormRules : {
        type: [{ required: true,message: '请选择',	trigger: 'change',}],
        mobileNo: [{ required: true,message: '请输入',	trigger: 'blur',}],
        fileId: [{ required: true,message: '请输入',trigger: 'blur', }],
      },

      //二维码文本信息
      orderObj : {
        accountId : '',
        orderId : '',
        shortUrl : '',
        flowId : '',
        qrCodeText : '',
      },
      //第二步骤，获取用户是否扫码验证 定时器
      step2CallBackLoopTimer : null,
    }
  },
  watch: {

  },
  created() {
    //获取签署人信息
    /*
    APIDict.getDictsByParentValue({value:'1006'}).then(res=>{
      this.typeDL = res.data
    })
     */
  },
  methods : {
    // 验证 步骤
    nextStep(){
      /*
      if(this.stepIndex == 1) {
        this.$refs.objectForm.validate(valid => {
              if (valid) {
                this.stepIndex++
                this.$emit('on-step-index', this.stepIndex)
                //创建用户扫码 请求定时器
                this.initStep2Timer()
              }
        })
      } else if(this.stepIndex == 2) {
        this.stepIndex++
        this.$emit('on-step-index', this.stepIndex)
      }
      return
      */
      if(this.stepIndex == 1) {
        this.$refs.objectForm.validate(valid => {
          if (valid) {
            this.startFlow()
          } else {
            //this.$message.warning('请完善必填项!')
          }
        })
      } else if (this.stepIndex == 2) {
        this.stepIndex++
      }
    },
    startFlow(){
      //验证验证码是否有效
      let files = this.objectForm.fileId.split(",")
      let param = {
        type : this.objectForm.type,
        mobileNo : this.objectForm.mobileNo,
        files : files
      }
      API.startFlow(param).then(res=>{
        if(res.operationCode == 1 && res.msg.indexOf('faild') < 0) {
          //验证成功，验证码有效
          //this.orderObj.qrCodeText = res.data.url
          Object.keys(this.orderObj).forEach(key=> this.orderObj[key] = res.data[key])
          this.orderObj.qrCodeText = res.data.shortUrl
          this.stepIndex++
          this.$emit('on-step-index', this.stepIndex)

          //创建用户扫码 请求定时器
          this.initStep2Timer()
        }else {
          this.$message.error(res.data);
        }
      })
    },

    //创建用户扫码 请求定时器
    initStep2Timer(){
      /*
      let second = 0
      this.step2CallBackLoopTimer = setInterval(() => {
        second ++
        if(second > 5) {
          this.resetStep2Timer()
          this.stepIndex++
        }
      }, 1000)
      return
       */
      this.step2CallBackLoopTimer = setInterval(() => {
        let param = {
          accountId : this.orderObj.accountId,
          orderId : this.orderObj.orderId,
          flowId : this.orderObj.flowId,
        }
        APIHistory.getOrderHistoryByReIds(param).then(res=>{
          if(res.operationCode == 1) {
            if(res.data && res.data.flowState == 2) {
              this.resetStep2Timer()
              this.stepIndex++
            } else if(res.data && (res.data.flowState == 3 || res.data.flowState == 4)){
              let msg = res.data.flowState == 3 ? '签署失败' : '拒签'
              this.$message.error(msg)
              this.resetStep2Timer()
            }
            /*
            else {
              this.$message.error("获取信息异常！")
              this.resetStep2Timer()
            }
             */
          }else {
            this.$message.error(res.msg)
            this.resetStep2Timer()
          }
        })
      }, 1000)
    },
    //重置2步骤获取 用户是否扫码验证 定时器
    resetStep2Timer(){
      console.log('resetStep2Timer')
      clearInterval(this.step2CallBackLoopTimer)
      Object.keys(this.orderObj).forEach(key=> this.orderObj[key] = '')
    },

    closeDialog(){
      this.$emit('on-success')
    },
  },
}
</script>

<style lang="less" scoped>
.initiate-cert-page {
  text-align: center;

  .dv-step1{
    padding: 55px 90px 80px 70px;

    .very-code-btn-normal {
      background: #256CCB;
    }
    .very-code-btn-disabled {
      color: #666666;
    }
  }

  .dv-step2{
    padding: 10px 10px 20px;

    .dv-tip{
      font-size: 16px;
    }

    .dv-qr-code{
      margin-top: 30px;

      .img-qr-code{
        width: 285px;
        height: 286px;
      }
    }
  }

  .dv-step3{
    padding: 50px 25px 50px 25px;
    text-align: center;

    .dv-tip{
      font-size: 16px;

      .dv-key-tip {
        color : #5858FF
      }
    }

    .dv-suc-btn {
      margin-top: 110px;


    }
  }
}
</style>